import {
  Backdrop,
  Box,
  CircularProgress,
  Typography,
  useTheme,
} from '@mui/material';
import useI18n, { Ti18nId } from 'hooks/useI18n';
import useNotification from 'hooks/useNotification';

interface Props {
  isLoading?: boolean;
  currentMenu?: Ti18nId | string;
  children: React.ReactNode;
}

const Layout = ({ isLoading = false, currentMenu, children }: Props) => {
  const { palette, zIndex } = useTheme();
  const { onSuccess } = useNotification();

  return (
    <Box minWidth={1200}>
      <Box
        sx={{
          display: 'flex',
          color: `${palette.primary.main}`,
          fontSize: '22px',
          gap: 1,
          marginLeft: '30px',
        }}
      >
        {currentMenu}
        <Typography
          sx={{ color: 'black', fontSize: '14px', lineHeight: '38px' }}
        >
          <span>
            (Only virtual patients of the corresponding school can be modified)
          </span>
        </Typography>
      </Box>
      <Box display="flex" height={'calc(100vh - 52px)'}>
        <Box
          component="main"
          flex={1}
          sx={{
            px: 2,
            py: 4,
            overflowY: 'auto',
          }}
        >
          {children}
        </Box>
      </Box>

      <Backdrop open={isLoading} sx={{ zIndex: zIndex.tooltip }}>
        <CircularProgress />
      </Backdrop>
    </Box>
  );
};

export default Layout;
